import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import LandingSoldOutMessageCampaigns from "../LandingSoldOutMessageCampaigns";
import {Button, FormControl} from "@mui/material";
import cat from "../../img/cat.png";
import LandingAutoComplete from "../LandingAutoComplete";

export default function Step0({postCode, aStep, setAStep, setStep, setCurrentVet, googlePlace, setGooglePlace, postcodes, ReactGA, setSponsorId, sponsorId, setSponsorName, sponsorName, setSponsorProgram, setSponsorCost, setSponsorMicrochipExtraCost, setSponsorEmailText, setSponsorLogo, defaultLogo, cmpId,  resetSelection,microchipOnly,setMicrochipOnly}) {
const [selectedOption, setSelectedOption] = useState(null);
    const [show, setShow] = useState(true);
    const [showVets, setShowVets] = useState(false);
    const [selectionVets, setSelectionVets] = useState([]);
    const [showVetsFailure, setShowVetsFailure] = useState(false);
	const [vouchersAvailable, setVouchersAvailable] = useState(0);
    const pc = postCode;
    const onStartOver = () => {
        resetSelection();        
        setStep(0);          
        window.gtag('event', 'action', {
                            category: 'User',
                            action: 'Clicked start over'
                        });
    };
    useEffect(() => {

        if (postcodes.filter(({pc}) => pc === parseInt(postCode)).length > 0) {
            // console.log('postCode',postCode);

            setShowVets(true);
            setShow(true);
            setShowVetsFailure(false);

            FunctionsData.fetchDataGetNoLoadingReturn(
                '/api/campaign/vets-postcode/'+pc
            ).then((r) => {
                console.log('setSelectionVets(r)',r)
                setSelectionVets(r)
            })

        } else {
            setShowVets(false);
            setSelectionVets([]);

            if (parseInt(postCode) > 0) {
                setShow(true);
                setShowVetsFailure(true);
            }
        }

    }, [postCode])


    if (show === true && showVetsFailure === true) return (
        <div className={"form"}>
            <ShowFailure {...{setStep,show,showVetsFailure,onStartOver}}/>
        </div>
    );

    return (
        <div>
            <div className={"form"}>
                <h3 style={{marginBottom: 20}}>Type your address to check if we currently offer a Snip'n'Chip campaign
                    in your area. </h3>
                <FormControl fullWidth sx={{textAlign: 'center'}}>
                    <LandingAutoComplete googlePlace={googlePlace}
                                         setGooglePlace={setGooglePlace}
                                         row={{...googlePlace, formatted_address: googlePlace.address}}
                                         ReactGA={ReactGA}
                    />
                </FormControl>
                <ShowVets {...{sponsorName,setCurrentVet,aStep,setAStep,showVets, selectionVets,sponsorId,postCode,setSponsorId, setSponsorName, setSponsorProgram, setSponsorCost , setSponsorMicrochipExtraCost, setSponsorEmailText, setSponsorLogo, defaultLogo,microchipOnly,setMicrochipOnly}} />
                <ShowNextButton postCode={pc}
                                aStep={aStep}
                                setAStep={setAStep}
                                setStep={setStep}
                                ReactGA={ReactGA}
                />
            </div>
             <Button
                onClick={() => {
                    window.gtag('event', 'action', {
                        category: 'User',
                        action: 'Clicked cancel application'
                    });
                    setStep(0)
                }}
                sx={{margin: 1}}
            >Cancel application
            </Button>
        </div>

    )
}

const ShowNextButton = ({setAStep,aStep,postCode}) => {

    if (1 === 1 || postCode === 'undefined' || postCode === '' || parseInt(postCode) === 0) return null;
    return (
        <div>
            <Button
                onClick={() => {
                    setAStep(aStep + 1)
                }}
                sx={{margin: 1, width: '100%'}}
            >Next
            </Button>
        </div>
    )
}

const ShowFailure = ({setStep,show,showVetsFailure,onStartOver}) => {

    if (show === false) return null;
    if (showVetsFailure === false) return null;
    return (
        <div className={"failure-box"}>

            <img src={cat} style={{width: '100%', marginTop: 0, marginBottom: 20}}/>

            <p>
                Thank you for looking to desex your pet. Currently there are no active Snip'n'Chip campaigns in your
                area. If you believe you are eligible for a Snip ‘n’ Chip campaign currently happening in your area,
                please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}
                                onClick={() => window.gtag('event', 'action', {
                                    category: 'User',
                                    action: 'Emailed snipnchip@spca.nz'
                                })}>snipnchip@spca.nz</a> and we can check this for you.
                We have compiled some other options that may help you with desexing your animal:
            </p>
            <p>
                <strong>Compare vet clinic prices:</strong>
                The cost can vary between vet clinics and we recommend calling around to compare prices. There are
                some vet clinics across the country that provide low cost desexing, as well as payment plans. Each
                vet clinic will be able to discuss their individual processes and requirements, and answer any
                questions you may have. Generally kittens will need to be at least 1kg (approximately 10-12 weeks
                old) before they can be desexed.
            </p>
            <p>
                <strong>Look into other services</strong>: Other organisations or social services in
                your area may be able to offer desexing services or provide financial assistance. Most of these can
                be found online through Google.
            </p>
            <p>
                <strong>Check in regularly at 'Help someone desex their pet':</strong> <a
                href={"https://www.facebook.com/Helpsomeonefixtheirpet/"} target={"_blank"}>Help Someone desex their
                pet</a> is a great resource page on Facebook that lists desexing options around the country and is
                updated regularly.
            </p>

            <p>
                 <Button variant={"contained"} style={{marginTop: 20, background: '#00C3B4'}} onClick={onStartOver}>Start over</Button>

            </p>

        </div>
    )
}

const ShowVets = ({sponsorName,setCurrentVet,aStep,setAStep, showVets, selectionVets,sponsorId,postCode,setSponsorId, setSponsorName, setSponsorProgram, setSponsorCost , setSponsorMicrochipExtraCost, setSponsorEmailText, setSponsorLogo, defaultLogo,microchipOnly,setMicrochipOnly}) => {

    const [campaignEmpty, setCampaignEmpty] = useState(0);
    const [sponsors, setSponsors] = useState(null);
    const [sponsorsLoading, setSponsorsLoading] = useState(true);
    const [campaignsLoading, setCampaignsLoading] = useState(true);

    useEffect(() => {

		if(parseInt(postCode) > 0) {
			FunctionsData.fetchDataGet(
				'/api/campaign/postcodes/' + postCode,
				setCampaignEmpty,
				true,
				setCampaignsLoading
			);
			
			FunctionsData.fetchDataGet(
				'/api/orders/sponsor/' + postCode,
				setSponsors,
				true,
				setSponsorsLoading
			);
			
		}else{
			setCampaignEmpty(0);
			setSponsors(null);
		}

    }, [postCode])

    useEffect(() => {

        try {
            if (sponsors.id > 0 && sponsors.optout_public === 0) {
                setSponsorId(sponsors.id);
                setSponsorName(sponsors.name);
                setSponsorProgram(sponsors.program);
                setSponsorCost(sponsors.applicant_cost);
                setSponsorMicrochipExtraCost(sponsors.microchip_extra_cost);
                setSponsorEmailText(sponsors.email_text_url);
                setSponsorLogo(sponsors.logo);
            }
        } catch (e) {
            setSponsorId(0);
            setSponsorName('');
            setSponsorProgram('');
            setSponsorCost(0.00);
            setSponsorMicrochipExtraCost(0.00);
            setSponsorEmailText('');
            setSponsorLogo(defaultLogo);
        }

    }, [sponsors])

    if (sponsorsLoading === true || campaignsLoading === true) return null;
    if (showVets === false) return null;
    if (!selectionVets) return null;

    if (selectionVets.length === 0 && parseInt(campaignEmpty ?? 0) > 0) {
        window.gtag('event', 'response', {
            category: 'Eligibility',
            action: 'Address not eligible'
        });
        return (
            <div className={"vet-box"}>
                <h3>No vets for your area available at this time. Please check in later.</h3>
            </div>
        )
    }

    window.gtag('event', 'response', {
        category: 'Eligibility',
        action: 'Address eligible'
    });

    if (microchipOnly) {
    selectionVets = selectionVets.filter(vet => vet.optout_microchiponly
 === 0);
    console.log(selectionVets);
}
    if (parseInt(campaignEmpty ?? 0) <= 0) return <LandingSoldOutMessageCampaigns/>;
    return (
        <div className={"vet-box"}>
            <div>
                <p>
                    Great, you are eligible for one of our current Snip'n'Chip campaigns in your post code
                    area {postCode}. There are {String(campaignEmpty ?? 0)} vouchers currently available.
                    {
                        (sponsorId > 0) ?
                            <span>&nbsp;<b>{sponsorName}</b> have generously provided funding towards this campaign.</span>
                            : undefined
                    }
                </p>
                <h3 style={{marginTop: 10}}>Please choose a vet from the list below.</h3>
            </div>
            {selectionVets.map((d, index) => {
                return (
                    <div key={d.id} className="vet-detail">
                        <h1>{d.business_name}</h1>
                        <p><strong>{d.street} {d.suburb}</strong></p>
                        <p><strong>{d.city} {d.postcode}</strong></p>
                        <p><b>Email</b>: {d.email} {(d.phone !== '' && d.phone !== '0') ?
                            <span>, <b>Phone</b>: {d.phone}</span> : undefined}</p>
                        {(d.supplier_hours !== '' && 'this' === 'deactivated') ?
                            <p><b>Hours</b>: {d.supplier_hours}</p> : undefined}
                        {(d.supplier_website !== '') ? <p><b>Website</b>: {d.supplier_website}</p> : undefined}
                        {(d.supplier_terms !== '') ? <p><b>T&Cs</b>: {d.supplier_terms}</p> : undefined}
                        <Button size="small" onClick={() => {
                            setCurrentVet(d.id);
                            setAStep(aStep + 1);
                            window.gtag('event', 'action', {
                                category: 'User',
                                action: 'Selected vet'
                            });
                        }} variant={"contained"} sx={{marginTop: 1}}>Select this Vet</Button>
                    </div>
                )
            })}
        </div>
    )
}
